/**
 * How long a presigned read URL the backend hands out stays valid, in seconds.
 *
 * One value for both sides of the wire: the backend clamps every presigned URL to
 * it, and a client that holds such URLs refreshes them on a period derived from it,
 * so the refresh cannot drift past the expiry when this changes.
 */
export const OBJECT_READ_URL_TTL_SECONDS = 3600;
